const o = {
  name: "ArrowCircleDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7V13.586L16.0002 10.5858L17.4144 12L12.0002 17.4142L6.58594 12L8.00015 10.5858L11 13.5857V7H13Z" fill="currentColor"/>
<path d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ArrowCircleDown
};
